import React, {useCallback, useEffect, useState} from 'react';
import {get, post} from '../api';
import RenderFormInput from '../components/cmp/formbuilder/RenderFormInput';
import StyledButton from '../components/cmp/themed/StyledButton';
import usePendingRequiredFields
  from '../components/cmp/hooks/usePendingRequiredInputs';
import FormattedHelmet from '../components/cmp/intl/FormattedHelmet';
import LogoRender from '../components/cmp/LogoRender';
import {FormattedMessage} from 'react-intl';
import {FiCheckCircle} from "react-icons/fi";

function CompleteProfileBeforeAccess() {
  const pending_input = usePendingRequiredFields();

  useEffect(() => {
    // pending input has w9 and w9 for this year is already submitted, check
    // get affiliate files
    const hasW9 = pending_input.some(({type})=>type === "w9")
    if(hasW9){
      get('/files').then((data)=>{
        const updateObject = {}
        pending_input.filter(({type})=>type === "w9")
            .forEach(({id, w9_year})=>{
          const found = data.find(({file_title})=> {
          const lowerTitle = (file_title || '').toLowerCase()
              return lowerTitle.startsWith("w9") || lowerTitle.startsWith('w8')
          })
          if(found){
            updateObject[id] = {
              url:found.url,
              file_id:found.file_id,
//              data: found.metadata ? JSON.parse(found.metadata) : null,
            }
          }
        })
        if(Object.keys(updateObject).length > 0){
          setValues((v)=>{
            return {
              ...v,
              ...updateObject,
            }
          })

        }

      })
    }
  }, [pending_input]);

  const [values, setValues] = useState({})
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null)
  const updateProfile = useCallback(()=>{
    setSaving(true)
    post('/', {
      formData:values,
      __from_page:"complete_profile_form"
    }).then((data) => {
      if (data.error) {
        setError(data.error)
      } else {
        setSaving(false)
        document.location.reload();
      }
    }).catch((e) => {
      setSaving(false)
      setError('Unexpected error')
    });
  },[values])

  const onChange = useCallback((key)=>{
    return (e)=>{
      setValues((v)=>{
        return {
          ...v,
          [key]:e.target.value
        }
      })
    }
  },[])

  return (
      <div className={"container"}>
        <div className="row pt-4">
          <div className="col-md-2"/>
          <div className="col-md-8">
              <FormattedHelmet id={'Complete your profile'}/>
              <div className={'text-center mb-4'}>
                <LogoRender/>
              </div>
            <h3 className={"text-center"}><FormattedMessage id={"Complete your profile"} /></h3>
            <p  className={"text-center"}><FormattedMessage id={"Before you can access your account, you need to complete your profile"} /></p>
            <div className="card">
              <div className="card-body">
                {
                  pending_input.length === 0 ? <div className={"text-center"}>
                    <FiCheckCircle className={"text-success font-weight-bold display-4 mb-2"} />
                    <h3>Thank You!</h3>
                    <p className="mb-0"><FormattedMessage id={"All required fields are completed"}/></p>
                  </div>
                  : <>
                    {
                      error ? <p className="text-danger">{error}</p> : null
                    }
                    <div className={'row flex-wrap'}>
                      {
                        pending_input.map((i)=>{
                          return <RenderFormInput
                              key={i.id}
                              {...i}
                              value={values[i.id]}
                              onChange={onChange(i.id)}
                          />
                        })
                      }
                      <div className="col-12">
                        <StyledButton disabled={Object.keys(values).length === 0} loading={saving} className="btn btn-primary"
                                      onClick={updateProfile} title={"Submit"}></StyledButton>
                      </div>
                    </div>
                  </>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default CompleteProfileBeforeAccess;
